
<template>
    <div class="read-time">
        <i :class="icon" />
        <span v-if="enableReadTimeText" class="read-time-text">
            {{ $translate('read_time', 'Lästid') }}
        </span>
        <span class="read-time-minutes">
            {{ $translate('wpm_read', '{readTime} min')
                .replace('{readTime}', formatReadMinutes) }} 
        </span>
    </div>
</template>

<script>
export default {
    props: {
        slices: {
            type: Array,
            required: true
        },
        enableReadTimeText: {
            type: Boolean,
            required: false,
            default: false
        },
        icon: {
            type: String,
            required: false,
            default: 'far fa-clock'
        }
    },
    data() {
        return {
            wpmRead: 183
        };
    },
    computed: {
        readTime() {
            const richTextSlices = this.slices.filter(item => item.slice_type === 'rich_text');
            const wordCount = richTextSlices.reduce((acc, slice) => {
                const words = this.$prismic.asText(slice.primary.rt_content).split(' ');
                return acc + words.length;
            }, 0);

            return wordCount / this.wpmRead;
        },
        formatReadMinutes() {
            if (this.readTime < 1) {
                return '< 1';
            }

            return this.$format.number(this.readTime);
        }
    }
};
</script>
